import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { SleeveSimpleAccounts } from '../models/move-to-different-sleeve.model'

const AGGREGATE_SUBACCOUNTS_URL = `helios-external-raw-data/account/subAccountMap/`
@Injectable({
  providedIn: 'root',
})
export class MoveToDifferentSleeveService {
  constructor(private readonly httpClient: HttpClient) {}
  fetchSubAccounts(accountId: number): Observable<SleeveSimpleAccounts[]> {
    return this.httpClient.get<SleeveSimpleAccounts[]>(
      `${AGGREGATE_SUBACCOUNTS_URL}` + accountId,
    )
  }
}
